const dealerRequests = {
  header: 'Lista de Distribuidores',
  dealer_requests: 'Solicitudes de Distribuidores',
  search_dealers: 'Buscar Distribuidores',
  confirm_modal_confirm: 'Si, eliminar',
  no_pending_requests: 'No hay solicitudes pendientes',
  approved: 'Aprobado',
  pending: 'Pendiente',
  denied: 'Denegado',
  in_review: 'En Revisión',
  approve: 'Aprobar',
  deny: 'Denegar',
  review: 'Revisar',
  all: 'Todo',
  submit: 'Enviar',
  update: 'Actualizar',
  edit: 'Editar',
  history: 'Historia',
  email_notifications: 'Notificationes de email',
  email_modal_description:
    'Esta lista de correo electrónico recibirá la solicitud de distribuidor',
  email_list_updated:
    'Lista de correos de solicitudes de distribuidor actualizada',
  dealer_request_updated: 'Solicitud de distribuidor actualizada',
  table: {
    company: 'COMPAÑÍA',
    full_name: 'NOMBRE COMPLETO',
    email: 'EMAIL',
    country: 'PAIS',
    date: 'FECHA',
    status: 'ESTADO',
  },
};

export default dealerRequests;
